// Screen breakpoints (in pixels) - for LAYOUT detection, not device detection
// Use useIsMobile() or useIsCompactLayout() hooks for responsive layouts
// Use usePlatformDetection() for actual device detection (iOS/Android)
export const screenSizes = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};

// Compact layout detection - includes both mobile and tablet sizes
export const isCompactLayout = (width = window.innerWidth) => width < screenSizes.lg; // < 1024px

// Mobile-only layout detection (excludes tablets)
export const isMobile = (width = window.innerWidth) => width < screenSizes.md; // < 768px

// Device size detection (mutually exclusive ranges)
export const isTablet = (width = window.innerWidth) => width >= screenSizes.md && width < screenSizes.lg; // 768px - 1023px
export const isDesktop = (width = window.innerWidth) => width >= screenSizes.lg; // >= 1024px

// Large desktop detection (sidebar default open, and TopActionBar More-menu fallback before width is measured)
export const isLargeDesktop = (width = window.innerWidth) => width >= screenSizes.xl; // >= 1280px

// Largest common iPad viewport (iPad Pro 12.9" landscape). Dashboard stays stacked at or below this.
export const IPAD_PRO_LANDSCAPE_MAX_WIDTH = 1366;

// Fixed layout heights (in pixels)
export const COMPACT_NAVBAR_REDESIGN_TOP_ACTION_BAR_HEIGHT = 56;
